"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Global Error Boundary:", error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
      <h2 className="text-2xl font-bold mb-4">Something went wrong 🙁</h2>
      <p className="text-gray-600 mb-6 max-w-md">
        We encountered an unexpected error. Don‘t worry, your data is safe.
      </p>
      
      {error.digest && (
        <code className="bg-gray-100 p-2 rounded text-xs mb-6">
          Error ID: {error.digest}
        </code>
      )}
      <div className="flex gap-4">
        <Button onClick={() => reset()} variant="default" radius="lg">
          Try again
        </Button>
        <Button onClick={() => (window.location.href = "/")} variant="outline" radius="lg">
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
}